import request from "@/global/request/request";
import API from "@/global/request/api";

const postService = {
  postList(params = {}) {
    return request.get(API.postTask, params);
  },
  postShow(id) {
    return request.get(API.postTaskItem(id));
  },
  postEdit(id, params = {}) {
    return request.put(API.postTaskItem(id), params);
  },
  postGroupStacks(id) {
    return request.get(API.postGroupStacks(id));
  },
  postSkillLevels(id) {
    return request.get(API.postSkillLevels(id));
  },
  postGroupStacksEdit(id, params = {}) {
    return request.put(API.postGroupStacks(id), params);
  },
  postSkillLevelEdit(id, params = {}) {
    return request.put(API.postSkillLevels(id), params);
  }
};

export default postService;
